import { BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";

import { filledString, filledUrls, resolveMindCatalogImageUrls } from "../utils/channel-content.util";

import { ChannelBrands, ChannelData, ChannelMenus } from "./umanager-slug.service";

@Injectable({ providedIn: 'root' })
export class ChannelConfigService {
  private brandsSubject = new BehaviorSubject<ChannelBrands | null>(null);
  brands$ = this.brandsSubject.asObservable();

  private menusSubject = new BehaviorSubject<ChannelMenus | null>(null);
  menus$ = this.menusSubject.asObservable();

  private channelData: ChannelData | null = null;

  private defaultHeaderLogo = 'https://mondrian.claro.com.br/brands/vertical/default/claro-empresas.svg';
  private defaultHeaderLogoInverse = 'https://mondrian.claro.com.br/brands/vertical/inverse/claro-empresas.svg';
  //TODO: confirmar a img 
  private defaultSuccessLogo = 'https://mondrian.claro.com.br/brands/horizontal/default/claro-empresas.svg';
  private defautlFooterLogo = 'https://mondrian.claro.com.br/brands/nosvg/assinatura-claro-60x60.png';

  setChannelData(channelData: ChannelData | null | undefined) {
    this.channelData = channelData ?? null;

    if (channelData?.brands) {
      try {
        const brands: ChannelBrands = JSON.parse(channelData.brands);
        this.brandsSubject.next(brands);

        if (brands.iconLogo) {
          this.setFavicon(brands.iconLogo);
        }
      } catch (e) {
        console.warn('Invalid brands JSON', e);
        this.brandsSubject.next(null);
      }
    } else {
      this.brandsSubject.next(null);
    }

    if (channelData?.menus) {
      try {
        const menus: ChannelMenus = JSON.parse(channelData.menus);
        this.menusSubject.next(menus);
      } catch (e) {
        console.warn('Invalid menus JSON', e);
        this.menusSubject.next(null);
      }
    } else {
      this.menusSubject.next(null);
    }
  }

  get catalogs(): string[] {
    const catalogs = this.channelData?.catalogs;
    if (!Array.isArray(catalogs)) {
      return [];
    }
    return catalogs.map(c => String(c).toUpperCase());
  }

  get hasMindCatalog(): boolean {
    return this.catalogs.includes('MIND');
  }

  get hasMovelCatalog(): boolean {
    return this.catalogs.includes('MOVEL');
  }

  get homeHeadline(): string | null {
    return filledString(this.channelData?.homeHeadline);
  }

  get homeSubheadline(): string | null {
    return filledString(this.channelData?.homeSubheadline);
  }

  get addressModalSubheadline(): string | null {
    return filledString(this.channelData?.addressModalSubheadline);
  }

  get referralHeadline(): string | null {
    return filledString(this.channelData?.referralHeadline);
  }

  get referralSubheadline(): string | null {
    return filledString(this.channelData?.referralSubheadline);
  }

  get referralRegulationUrl(): string | null {
    return filledString(this.channelData?.referralRegulationUrl);
  }

  get referralButtonLabel(): string | null {
    return filledString(this.channelData?.referralButtonLabel);
  }

  get referralBannerUrl(): string | null {
    return filledString(this.channelData?.referralBannerUrl);
  }

  get referralBannerMobileUrl(): string | null {
    return filledString(this.channelData?.referralBannerMobileUrl);
  }

  get mindImageUrls(): string[] | null {
    return filledUrls(this.channelData?.mindImageUrls);
  }

  get mindCatalogImageUrls(): string[] | null {
    return resolveMindCatalogImageUrls(
      this.hasMindCatalog,
      this.channelData?.mindImageUrls
    );
  }

  /**
   * Affiliate id do canal (Mind createOrder).
   * Vazio/nulo no response → string vazia.
   */
  get affiliateId(): string {
    const value = this.channelData?.affiliateId;
    if (value == null) {
      return '';
    }
    return String(value).trim();
  }

  getHeaderLogo(brands?: ChannelBrands | null): string {
    return brands?.headerLogo || this.defaultHeaderLogo;
  }

  getInverseHeaderLogo(brands?: ChannelBrands | null): string {
    if (brands?.headerLogo) {
      return brands.headerLogo;
    }
    return this.defaultHeaderLogoInverse;
  }

  /*getSuccessLogo(brands?: ChannelBrands | null): string {
    return brands?.footerLogo || this.defaultSuccessLogo;
  }*/

  getFooterLogo(brands?: ChannelBrands | null): string {
    return brands?.footerLogo || this.defautlFooterLogo;
  }

  setFavicon(url: string) {
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.href = url + '?v=' + Date.now(); 
  }

   showIndique(menus?: ChannelMenus | null): boolean {
    return menus?.indique !== false;
  }

  showParceiros(menus?: ChannelMenus | null): boolean {
    return menus?.parceiros !== false;
  }

  get showIndiqueMenu(): boolean {
    return this.menusSubject.value?.indique !== false;
  }

  get showParceirosMenu(): boolean {
    return this.menusSubject.value?.parceiros !== false;
  }

  get onlyIndication(): boolean {
    return this.menusSubject.value?.['onlyIndication'] === true;
  }

}
